import { createContext, useContext } from "react"

export interface GroupPermissionContextValue {
  permissions: string[]
}

const defaultValue: GroupPermissionContextValue = {
  permissions: [],
}

export const GroupPermissionContext =
  createContext<GroupPermissionContextValue>(defaultValue)

export const useGroupPermission = () => useContext(GroupPermissionContext)
